import { useHistory } from 'react-router-dom';
import { formatDateBR, isValidDate } from '../../../../../../../utilities/date';

interface Props {
  id: string;
  produtor: string;
  nAmostra: string;
  especie: string;
  dataEntrada: Date | null;
  dataAnalise?: Date;
  status: string;
  progresso: string;
  repeticaoRejeitada?: number;
}

export default function ListaTetrazolioItem({
  id, produtor, nAmostra, especie, dataEntrada, dataAnalise, status, progresso, repeticaoRejeitada,
}: Props) {
  const history = useHistory();
  const isDataEntradaValida = isValidDate(dataEntrada);

  let statusClass = '';
  if (status.toLowerCase() === 'iniciado') {
    statusClass = 'iniciado';
  } else if (status.toLowerCase() === 'realizado') {
    statusClass = 'realizado';
  } else if (status.toLowerCase() === 'pendente') {
    statusClass = 'pendente';
  }

  const handleClick = () => {
    history.push(`/sementes/tetrazolio/${id}`);
  };

  return (
    <div
      className="card card-clickable"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
    >
      <div>{produtor}</div>
      <div><strong>{nAmostra}</strong></div>
      <div>{especie}</div>
      <div>{isDataEntradaValida ? formatDateBR(dataEntrada) : ''}</div>
      <div>{dataAnalise ? dataAnalise.toLocaleDateString('pt-BR') : '--'}</div>
      <div>
        <span className={`status ${statusClass}`}>{status}</span>
      </div>
      <div className="progresso-grid">
        {(() => {
          // Extrai todas as repetições (ex: "R1: 0/50", "R2: 50/50", etc)
          const todasRepeticoes = progresso.match(/R\d+:\s*\d+\/\d+/g) || [];

          // Separa em ímpares e pares
          const impares: string[] = [];
          const pares: string[] = [];

          todasRepeticoes.forEach((repeticao) => {
            const match = repeticao.match(/^R(\d+):/);
            const numeroRepeticao = match ? Number(match[1]) : 0;
            if (numeroRepeticao % 2 === 1) {
              impares.push(repeticao);
            } else {
              pares.push(repeticao);
            }
          });

          return (
            <>
              <div className="progresso-coluna">
                {impares.map((repeticao, index) => {
                  const match = repeticao.match(/^R(\d+):/);
                  const numeroRepeticao = match ? Number(match[1]) : null;
                  const isRejeitada = numeroRepeticao === repeticaoRejeitada;

                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <span
                      key={`impar-${index}`}
                      className={isRejeitada ? 'repeticao-rejeitada' : ''}
                    >
                      {repeticao}
                    </span>
                  );
                })}
              </div>
              <div className="progresso-coluna">
                {pares.map((repeticao, index) => {
                  const match = repeticao.match(/^R(\d+):/);
                  const numeroRepeticao = match ? Number(match[1]) : null;
                  const isRejeitada = numeroRepeticao === repeticaoRejeitada;

                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <span
                      key={`par-${index}`}
                      className={isRejeitada ? 'repeticao-rejeitada' : ''}
                    >
                      {repeticao}
                    </span>
                  );
                })}
              </div>
            </>
          );
        })()}
      </div>
      <div className="chevron">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M9 18L15 12L9 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
}
